import moment from 'moment-jalaali';
import Swal from 'sweetalert2';
import { API_URL } from "../env";
import Http from "../services/http.init";

export default {
	install(Vue) {
		Vue.prototype.$http = new Http()
		Vue.prototype.$scrollToTop = () => {
		  const element = document.getElementById("main-panel")
			element.scrollTo({top: 0, left: 0, behavior: 'smooth'})
		}
		Vue.prototype.$normalNum = (val) => {


			if (!val || val == 0)
				return val


			if (val.match(/,\s?/g))
				if (val != '' || val != null)
					val = val.replace(/,\s?/g, '')

			return Number(val)
		}
		Vue.prototype.$priceMask = (val, precision = 0) => {
			if (!val)
				return

			let nStr = String(val)
			let rgxNumOnly = /[^0-9.]/g

			nStr = nStr.replace(/\,/g, '')
			if (rgxNumOnly.test(nStr)) {

				nStr = nStr.replace(/[^0-9.]/g, '')
				return nStr
			}

			let x = nStr.split('.')
			let x1 = x[0]
			let x2 = x.length > 1 ? '.' + x[1] : ''
			let rgx = /(\d+)(\d{3})/
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + ',' + '$2')
			}
			return x1 + x2
		}

		Vue.prototype.$dateTimeFormat = (date, lang = 'fa') => {
			if (!date) {
				return '---'
			}
			if (new Date(date).getTime() < 0)
				return '---'
			let format
			if (lang === 'fa') {
				format = 'jYYYY/jMM/jDD ساعت HH:mm'
			} else {
				format = 'DD-MM-YYYY HH:mm'
			}

			const dt = new Date(date)

			return moment(dt).format(format)
		}
		Vue.prototype.$typeToPersian = (name) => {
			if (!name) {
				return '---'
			}
			let result;
			switch (name) {
				case 'STORY':
					result = 'داستان'
					break;
				default:
					result = name
			}
			return result
		}
		Vue.prototype.$confirmAlert = async (title = 'آیا مطمئن هستید؟', confirmButtonText = 'بله، پاکش کن!') => {
			const confirm = await Swal.fire({
				title: title,
				// text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'نه، مطمئن نیستم!',
				confirmButtonText
			})
			return confirm.value || false
		}
		Vue.prototype.$successAlert = async (title = 'موفقیت آمیز.') => {
			const success = await Swal.fire({
				icon: 'success',
				title: title,
				showConfirmButton: false,
				timer: 1500
			})
		}
		Vue.prototype.$errorAlert = async (title = 'خطا!', message = 'مشکلی پیش آمد!') => {
			const error = await Swal.fire({
				icon: 'error',
				title: title,
				html: message,
				confirmButtonText: 'باشه!',
			})
		}
		// this method generate query by just filter and sort
		Vue.prototype.$queryGenerator = (filter, sort) => {

			let url;
			const hasFilter = Object.keys(filter).length > 0
			if (!hasFilter && !sort)
				url = '';
			else if (hasFilter && !sort)
				url = `filters=${JSON.stringify(filter)}`
			else if (!hasFilter && sort)
				url = `sort=${sort}`
			else if (hasFilter && sort)
				url = `filters=${JSON.stringify(filter)}&sort=${sort}`

			return url
		}

		Vue.prototype.$fileManagerFile = (src, asUrl = false) => {
			let ret = ''
			if (src && src.indexOf('http') === 0) {
				ret = src
			} else if (src) {
				ret = `${API_URL}/media/download/${src}`
			} else {
				ret = ''
			}
			if (asUrl) {
				return `url('${ret.trim()}')`
			}
			return ret.trim()
		}
		Vue.prototype.$generateFilter = async (filter) => {
			if ('enabled' in filter && !filter['enabled']) {
				filter['enabled'] = {'$ne':true};
			}
			const newFilter = JSON.parse(JSON.stringify(filter))
			if (Object.keys(newFilter).length)
				await Object.keys(newFilter).map(async (val) => {
					if (typeof newFilter[val] === 'string') {
						if (!newFilter[val] || !newFilter[val].split(' ').join(''))
							delete newFilter[val]
					} else if (Array.isArray(newFilter[val]) && newFilter[val].length && typeof newFilter[val][0] === 'string') {
						newFilter[val] = {$in: newFilter[val]}
					}
				})
			return newFilter
		}
		Vue.prototype.$validateFilter = async (filter) => {
			const newFilter = JSON.parse(JSON.stringify(filter))
			if (Object.keys(newFilter).length)
				await Object.keys(newFilter).map(async (val) => {
					if (typeof newFilter[val] === 'string') {
						if (!newFilter[val] || !newFilter[val].split(' ').join(''))
							delete newFilter[val]
					} else if (Array.isArray(newFilter[val]) && newFilter[val].length === 0) {
						delete newFilter[val]
					}
				})
			return newFilter
		}
	}
}
